/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Filter_Role_AriaInputs */



/**
* | output |
* | --- |
* | "Filter by role" |
*
* @param {Team_Manager_Filter_Role_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_filter_role_aria = /** @type {((inputs?: Team_Manager_Filter_Role_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Filter_Role_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtrer par rôle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nach Rolle filtern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtra per ruolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтр по роли")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtrar por rol")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按角色筛选")
	if (locale === "ja") return /** @type {LocalizedString} */ ("役割で絞り込み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भूमिका के अनुसार फ़िल्टर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtrar por função")
	return /** @type {LocalizedString} */ ("Filter by role")
});